export default __webpack_public_path__ + "static/media/calendar-new.2c275ab8.svg";